import React from 'react'
import './portfolio.css'



const Portfolio=()=>{
    return(
        <section className="recent-work" id='portfolio'>
            <div className='container'>
                <h1>My Recent Work</h1>
                <h4>Coming Soon...</h4>
            </div>
        </section>
    )
}

export default Portfolio;

